export default class TabsContenus {
    constructor(element) {
        this.element = element
        this.triggers = Array.from(this.element.querySelectorAll('.tab-trigger'))
        this.inlinePanels = Array.from(this.element.querySelectorAll('.tab-panel--inline'))
        this.desktopPanel = this.element.querySelector('[data-tabs-panel]')
        this.desktopPanelInner = this.desktopPanel?.querySelector('.tab-panel__inner')
        this.breakpoint = window.matchMedia('(min-width: 768px)')
    }

    start() {
        if (!this.triggers.length) {
            return
        }

        this.triggers.forEach((trigger, index) => {
            trigger.addEventListener('click', () => {
                this.activate(index, true)
            })
        })

        this.activate(this.getActiveIndex(), false)
        window.addEventListener('resize', () => this.syncDesktopPanel())
        window.addEventListener('resize', () => this.syncAriaHidden())
        this.syncAriaHidden()
    }

    getActiveIndex() {
        const activeIndex = this.triggers.findIndex(trigger => trigger.classList.contains('is-active'))
        return activeIndex >= 0 ? activeIndex : 0
    }

    activate(index, shouldFocus) {
        this.triggers.forEach((trigger, i) => {
            const isActive = i === index
            trigger.classList.toggle('is-active', isActive)
            trigger.setAttribute('aria-selected', isActive ? 'true' : 'false')
            trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false')

            if (this.inlinePanels[i]) {
                this.inlinePanels[i].classList.toggle('is-open', isActive)
                this.inlinePanels[i].setAttribute('aria-hidden', isActive ? 'false' : 'true')
            }
        })

        this.syncDesktopPanel(index)
        this.syncAriaHidden()

        if (shouldFocus && this.triggers[index]) {
            this.triggers[index].focus()
        }
    }

    syncDesktopPanel(index = this.getActiveIndex()) {
        if (!this.desktopPanel || !this.desktopPanelInner || !this.breakpoint.matches) {
            return
        }

        const activePanel = this.inlinePanels[index]
        const activeInner = activePanel?.querySelector('.tab-panel__inner')

        if (!activeInner) {
            return
        }

        this.desktopPanel.classList.remove('is-visible')

        window.requestAnimationFrame(() => {
            this.desktopPanelInner.innerHTML = activeInner.innerHTML
            window.requestAnimationFrame(() => {
                this.desktopPanel.classList.add('is-visible')
            })
        })
    }

    syncAriaHidden() {
        if (!this.desktopPanel) {
            return
        }

        if (this.breakpoint.matches) {
            this.desktopPanel.setAttribute('aria-hidden', 'false')
            this.inlinePanels.forEach(panel => {
                panel.setAttribute('aria-hidden', 'true')
            })
            return
        }

        this.desktopPanel.setAttribute('aria-hidden', 'true')
        this.inlinePanels.forEach((panel, index) => {
            const isActive = this.triggers[index]?.classList.contains('is-active')
            panel.setAttribute('aria-hidden', isActive ? 'false' : 'true')
        })
    }
}
